/* eslint-disable prefer-spread */
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import styled from 'styled-components';
import SpinnerCircular from '~/components/shared/Spinner/SpinnerCircular';
import { theme } from '~/styles/themes';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const InvoicePdfContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .pageBorder {
    border-bottom: 1px solid #d2d2d2;
  }
`;

interface Props {
  isMobile: boolean;
  singleInvoicePDF: string | undefined;
  showPageNumber?: boolean;
}

const InvoicePDF: React.FC<Props> = (props) => {
  const { isMobile, singleInvoicePDF, showPageNumber } = props;

  const [localNumPages, setLocalNumPages] = useState(0);

  function onDocumentLoadSuccess({ numPages }: any) {
    setLocalNumPages(numPages);
  }

  const displayPDF = () => {
    if (singleInvoicePDF) {
      return (
        <Document file={singleInvoicePDF} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.apply(null, Array(localNumPages))
            .map((x: number, i: number) => i + 1)
            .map((page: number, key: number) => (
              <Page
                className="pageBorder"
                key={key}
                width={isMobile ? 300 : 700}
                pageNumber={page}
              />
            ))}
          {showPageNumber && localNumPages}
        </Document>
      );
    }
    return <SpinnerCircular color={theme.colors.secondary} />;
  };

  return <InvoicePdfContainer>{displayPDF()}</InvoicePdfContainer>;
};

export default InvoicePDF;
